/**
 * Free trial period configuration.
 *
 * During this period, club registration is FREE — no Mollie payment is created,
 * and the club is set up directly with `club_subscriptions.status = 'trialing'`.
 *
 * Centralized here so frontend and edge functions share one source of truth.
 * Edge functions cannot import from `src/`, so they keep their own copy of
 * the same ISO date — update both when changing.
 */
export const FREE_TRIAL_UNTIL_ISO = "2026-10-31T23:59:59+02:00";
export const FREE_TRIAL_UNTIL_MS = new Date(FREE_TRIAL_UNTIL_ISO).getTime();

export function isTrialActive(now: Date = new Date()): boolean {
  return now.getTime() <= FREE_TRIAL_UNTIL_MS;
}

export const FREE_TRIAL_LABEL_NL = "gratis t/m 31 oktober 2026";
export const FREE_TRIAL_SHORT_NL = "Gratis t/m okt 2026";
